export const JOINT_TAB_PHYSICS_ON_NOTICE =
  "Physics is running. Use actuator controls to affect the simulation.";

export const PANEL_MODES = {
  JOINTS: "joints",
  ACTUATORS: "actuators",
};

export const SPEED_ACTUATOR_KINDS = new Set(["motor", "velocity", "intvelocity"]);

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
